import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Paper, Button } from '@material-ui/core'
import { showNotification } from 'react-admin'
import { Title } from 'react-admin'
import SaveIcon from '@material-ui/icons/Save'
import { post } from '@lib/request'
import { to, redirectTo, getChainId } from '@lib'
import { DEFAULT_API_ADMIN, PARTNER_ROUTES } from '@/constants'
import { MaskCellPhone, MaskCNPJ, MaskCep } from '../../components'
import { FormInput } from '../../components/PageComponents'
import {
  PartnerFormStyles as style,
  parseFormData,
  checkEmptyFields,
  fetchCep,
  removeMask,
} from '../../formLib'

const defaultState = { value: '', touched: false }

const SAVE_PARTNER_URL = `${DEFAULT_API_ADMIN}/chains/${getChainId()}/partners`

const CreatePartner = ({ showNotification }) => {
  const [partner, setPartner] = useState({
    cep: defaultState,
    city: defaultState,
    cnpj: defaultState,
    name: defaultState,
    neighbourhood: defaultState,
    phone: defaultState,
    state: defaultState,
    street: defaultState,
    streetNumber: defaultState,
    contact: { ...defaultState, nullable: true },
  })

  const submitForm = async value => {
    const url = SAVE_PARTNER_URL

    const [err, resource] = await to(post(url, value))

    if (err) {
      showNotification(err.message, 'warning')
      return
    }

    showNotification('Item criado com sucesso!')
    redirectTo(PARTNER_ROUTES.EDIT(resource.data.id))
  }

  const handleChange = field => e => {
    setPartner({
      ...partner,
      [field]: { value: e.target.value, touched: true },
    })
  }

  const handleCep = async event => {
    const {
      target: { value },
    } = event
    setPartner({ ...partner, cep: { value, touched: true } })

    if (removeMask(value).length === 8) {
      const errorMessage = await fetchCep(value, partner, setPartner)
      errorMessage && showNotification(errorMessage, 'warning')
    }
  }

  const handleSubmit = async () => {
    if (checkEmptyFields(partner, setPartner)) {
      showNotification(
        'Este formulário não está válido. Certifique-se de corrigir os erros!',
        'warning',
      )
      return
    }
    const formData = parseFormData(partner)
    await submitForm(formData)
  }

  const checkCep = partner.cep.value.trim().length !== 10

  return (
    <Paper style={style.PaperStyle}>
      <Title title="Cadastrar novo parceiro" />
      <FormInput
        label="Nome *"
        field={partner.name}
        onChange={handleChange('name')}
        isRequired
      />
      <FormInput
        label="CEP *"
        field={partner.cep}
        onChange={e => handleCep(e)}
        isRequired
        inputComponent={MaskCep}
      />
      <FormInput
        label="Rua *"
        field={partner.street}
        onChange={handleChange('street')}
        isRequired
        disabled={checkCep}
      />
      <FormInput
        label="Número *"
        field={partner.streetNumber}
        onChange={handleChange('streetNumber')}
        isRequired
      />
      <FormInput
        label="Bairro *"
        field={partner.neighbourhood}
        onChange={handleChange('neighbourhood')}
        isRequired
        disabled={checkCep}
      />
      <FormInput
        label="Cidade *"
        field={partner.city}
        onChange={handleChange('city')}
        isRequired
        disabled={checkCep}
      />
      <FormInput
        label="Estado *"
        field={partner.state}
        onChange={handleChange('state')}
        isRequired
        disabled={checkCep}
        inputProps={{ maxLength: 2 }}
        aditionalValidation={partner.state.value.length < 2}
      />
      <FormInput
        label="Telefone *"
        field={partner.phone}
        onChange={handleChange('phone')}
        isRequired
        inputComponent={MaskCellPhone}
      />
      <FormInput
        label="CNPJ *"
        field={partner.cnpj}
        onChange={handleChange('cnpj')}
        isRequired
        inputComponent={MaskCNPJ}
      />
      <FormInput
        label="Contato"
        field={partner.contact}
        onChange={handleChange('contact')}
      />
      <div style={style.ButtonWrapper}>
        <Button variant="contained" color="secondary" onClick={handleSubmit}>
          <SaveIcon style={style.IconStyle} />
          Salvar
        </Button>
      </div>
    </Paper>
  )
}

export default connect(
  null,
  { showNotification },
)(CreatePartner)
